import React from 'react';
import moment from 'moment';

class TimeAgo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeAgo: this.calculateTimeAgo(props.timestamp),
    };
  }

  componentDidMount() {
    // Update every minute
    this.interval = setInterval(() => {
      this.setState({
        timeAgo: this.calculateTimeAgo(this.props.timestamp),
      });
    }, 60000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  calculateTimeAgo = (timestamp) => {
    if (!timestamp) return '—';

    // Moment automatically parses ISO 8601 strings like "2025-10-11T11:10:54.581055Z"
    const now = moment();
    const posted = moment(timestamp);

    // Handle invalid dates gracefully
    if (!posted.isValid()) return 'Invalid date';

    const years = now.diff(posted, 'years');
    const months = now.diff(posted, 'months');
    const days = now.diff(posted, 'days');
    const hours = now.diff(posted, 'hours');
    const minutes = now.diff(posted, 'minutes');

    if (years > 0) {
      const remainingMonths = months - years * 12;
      return `${years} year${years !== 1 ? 's' : ''}${remainingMonths > 0 ? ` and ${remainingMonths} month${remainingMonths !== 1 ? 's' : ''}` : ''} ago`;
    } else if (months > 0) {
      const remainingDays = days - months * 30;
      return `${months} month${months !== 1 ? 's' : ''}${remainingDays > 0 ? ` and ${remainingDays} day${remainingDays !== 1 ? 's' : ''}` : ''} ago`;
    } else if (days > 0) {
      const remainingHours = hours - days * 24;
      return `${days} day${days !== 1 ? 's' : ''}${remainingHours > 0 ? ` and ${remainingHours} hour${remainingHours !== 1 ? 's' : ''}` : ''} ago`;
    } else if (hours > 0) {
      const remainingMinutes = minutes - hours * 60;
      return `${hours} hour${hours !== 1 ? 's' : ''}${remainingMinutes > 0 ? ` and ${remainingMinutes} minute${remainingMinutes !== 1 ? 's' : ''}` : ''} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    } else {
      return 'just now';
    }
  };

  render() {
    return <span>{this.state.timeAgo}</span>;
  }
}

export default TimeAgo;
